module.exports = __webpack_public_path__ + "static/media/marketplace-product-img-4.5e6fcc8e.svg";